import logo from './logo.svg';
import './App.css';
import VerifyEmail from './pages/VerifyEmail';
import Signup from './pages/Signup';
import Cart from './components/core/Dashboard/Cart';
import { signUp } from './services/operations/authAPI';
import { Route, Routes } from 'react-router-dom';
import Home from "./pages/Home"; 
import LoginPage from "./pages/Login";
import Navbar from "./components/common/Navbar";
import ForgotPassword from './pages/ForgotPassword';
import UpdatePassword from './pages/UpdatePassword';
import Error from "./pages/Error";
import About from './pages/About';
import ContactUs from './pages/ContactUs';
import Dashboard from './pages/Dashboard';
import MyProfile from './components/core/Dashboard/MyProfile';
import OpenRoute from './components/core/HomePage/Auth/OpenRoute';
import PrivateRoute from './components/core/HomePage/Auth/PrivateRoute';
import EnrolledCourses from './components/core/Dashboard/EnrolledCourses';
import PurchaseHistory from './components/core/Dashboard/PurchaseHistory';
import Settings from './components/core/Dashboard/Settings';
import { ACCOUNT_TYPE } from './utils/constants';
import { useSelector } from 'react-redux';
import AddCourse from './components/core/Dashboard/AddCourse';
import MyCourses from './components/core/Dashboard/MyCourses';
import EditCourse from './components/core/Dashboard/EditCourse';
import Catalog from './pages/Catalog';
import CourseDetails from './pages/CourseDetails';
import ViewCourse from './pages/ViewCourse';
import VideoDetails from './components/core/ViewCourse/VideoDetails';
import Instructor from './components/core/Dashboard/InstructorDashboard/Instructor';
function App() {
  const {user}=useSelector((state)=>state.profile);
  return (
    <div className="w-screen min-h-screen bg-richblack-900 flex flex-col font-inter">
    <Navbar/>
     <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="catalog/:catalogName" element={<Catalog/>}/>
                <Route path="courses/:courseId" element={<CourseDetails/>}/>
        <Route path="/login" element={<OpenRoute>
        <LoginPage/>
              </OpenRoute>} />
        <Route path="/verify-email" element={
          <OpenRoute>
               <VerifyEmail/>
              </OpenRoute>
        }/>
        <Route path="/signup" element={<OpenRoute>
                <Signup/>
              </OpenRoute>}/>
        <Route path="/forgot-password" element={
          <OpenRoute>
              <ForgotPassword/>
              </OpenRoute>
        }/>
        <Route path="/update-password/:id" element={
          <OpenRoute>
        <UpdatePassword/>
              </OpenRoute>
        }/>
        <Route path="/error"  element={<Error/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/contact" element={<ContactUs/>}/>
        
       {/* Routes for Outlet */}

       <Route 
        element={
          <PrivateRoute>
            <Dashboard/>
          </PrivateRoute>
        }>

           <Route path="/dashboard/my-profile" element={<MyProfile/>}/> 
           
           <Route path="/dashboard/settings" element={<Settings/>}/> 
          
           {
  user?.accountType === ACCOUNT_TYPE.STUDENT && (
    <>
      <Route path="/dashboard/cart" element={<Cart />} />
      <Route path="/dashboard/enrolled-courses" element={<EnrolledCourses />} />
    </>
  )
}

{
  user?.accountType === ACCOUNT_TYPE.INSTRUCTOR && (
    <>
      <Route path="/dashboard/add-course" element={<AddCourse />} />
       <Route path="/dashboard/my-courses" element={<MyCourses />} />
             <Route path="dashboard/instructor" element={<Instructor />} />
              <Route path="/dashboard/edit-course/:courseId" element={<EditCourse/>} />
    </>
  )
}


        </Route>
        

<Route 
element={
  <PrivateRoute>
    <ViewCourse/>
  </PrivateRoute>
}
>


{user?.accountType===ACCOUNT_TYPE.STUDENT && (
  <>
    <Route path="view-course/:courseId/section/:sectionId/sub-section/:subSectionId"
      element={<VideoDetails/>}
    />
  </>
)}

</Route>




      
      </Routes>
 
    </div>
  );
}

export default App;
